
















import { Component, Emit, Vue } from 'vue-property-decorator'
import { PaginatedResponse, StreamItems } from '@/modules/firebase/firestore'
import StreamCard from '@/components/ui/StreamCard.vue'
import { StreamItem } from '@/types/stream'

// TODO:
//  Load more on swipe up/down.

@Component({
    components: {
        StreamCard
    }
})
export default class Home extends Vue {
    paginatedData: PaginatedResponse<StreamItems, StreamItem>|null = null
    loadingNext = false
    db = new StreamItems()

    @Emit('loading')
    isLoading(value: boolean): boolean {
        return value
    }

    async mounted() {
        this.listenToUpdates()
    }

    async loadData() {
        this.isLoading(true)
        this.paginatedData = await this.db.list()
        this.isLoading(false)
    }

    listenToUpdates() {
        // https://firebase.google.com/docs/firestore/query-data/listen
        this.db.collection.onSnapshot({}, () => {
            this.loadData()
        })
    }

    get stream(): StreamItem[] {
        return this.paginatedData?.items || []
    }

    async fetchNext(intersect: IntersectionObserverEntry[]) {
        if (this.paginatedData?.hasAfter && intersect[0].isIntersecting && !this.loadingNext) {
            this.loadingNext = true
            await this.paginatedData.listNext()
            setTimeout(() => {
                this.loadingNext = false
            }, 2000)
        }
    }
}
